import React from 'react';
import { Zap } from 'lucide-react';
export function FloatingCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-gradient-to-t from-[#0A0E17] to-transparent backdrop-blur-md" data-id="element-102" data-mp="21v4z7q181w0c">
      <a href="https://pay.hotmart.com/I106896154S" target="_blank" rel="noopener noreferrer" onClick={() => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'InitiateCheckout');
      }
    }} className="flex items-center justify-center gap-2 w-full bg-gradient-to-br from-violet to-violet-dark text-white font-body text-base font-bold px-5 py-4 rounded-xl shadow-[0_4px_20px_rgba(124,58,237,0.5)] active:scale-95 transition-transform" data-id="element-103" data-mp="1wwv6rn6vt9if">
        <Zap className="w-4 h-4 fill-white" data-id="element-104" data-mp="2atqqc9krejcq" />
        QUIERO MI PACK — $9.99 USD
      </a>
    </div>;
}